import { UserModel } from "../../app/modules/auth/models/UserModel";
import { exportWorkbook, getColumnLetter, setColumnWidths } from "./helperTemplateExcel";
import * as ExcelJS from 'exceljs';
import { addWorkSheetInfo, createWorksheet, styleColumns } from "./helperTemplateExcel";
import { createWorkbook } from "./helperTemplateExcel";
import { MasterCurrency } from "../../interfaces/Currency";
import { IntlShape } from "react-intl";
import { getCellNote } from "./functionHelperExcel";

interface ExportTemplateProductExcelProps {
    intl: IntlShape
    nameFile: string,
    nameInfo: string,
    nameHeader: any,
    source: string,
    typeAction: string,
    user: UserModel,
    param: any,
    type: string,
    setIsLoading: React.Dispatch<React.SetStateAction<boolean>>
    multiCurrencies: MasterCurrency[]
    databasePipelineTitle: string
}

export const exportTemplateProductExcel = async ({ intl, nameFile, nameInfo, nameHeader, source, typeAction, user, param, type, setIsLoading, multiCurrencies, databasePipelineTitle }: ExportTemplateProductExcelProps) => {
    let exportData: any[] = [];
    const workbook = createWorkbook();
    const worksheet = createWorksheet(workbook, "Sheet1");
    const worksheetInfo = createWorksheet(workbook, "Info");
    var header: string[] = []
    var subHeader: string[] = []

    // Data Label
    let worksheetLabel = workbook.addWorksheet('Daftar Label');
    await worksheetLabel.protect('mjioerh3uiqWHEIOPHQWIOPEJHDWBH', {
        formatColumns: true,
        autoFilter: true,
    });
    worksheetLabel.getCell('A1').value = `Daftar Label`;
    await param.dataLabels.forEach((label: any) => {
        worksheetLabel.addRow([label.name]);
    });

    // Data Satuan
    let worksheetUnit = workbook.addWorksheet('Daftar Satuan');
    await worksheetUnit.protect('mjioerh3uiqWHEIOPHQWIOPEJHDWBH', {
        formatColumns: true,
        autoFilter: true,
    });

    worksheetUnit.getCell('A1').value = `Daftar Satuan`;
    await param.dataUnits.forEach((unit: any) => {
        worksheetUnit.addRow([unit.name]);
    });

    let worksheetTemplatePipeline = workbook.addWorksheet(`Daftar Database ${databasePipelineTitle}`);
    await worksheetUnit.protect('mjioerh3uiqWHEIOPHQWIOPEJHDWBH', {
        formatColumns: true,
        autoFilter: true,
    });

    worksheetTemplatePipeline.getCell('A1').value = `Daftar Database ${databasePipelineTitle}`;
    const allOption = [{ name: intl.formatMessage({ id: "FORM.LABEL.ALL" }, { title: intl.formatMessage({ id: "FORM.LABEL.TEMPLATE" }, { title: databasePipelineTitle }) }), value: 'all' }]
    const multiPipelines = await param.multiPipelines
    const newValuesMultiPipeWithAllOption = [...allOption, ...multiPipelines]
    newValuesMultiPipeWithAllOption.forEach((pipeline: any) => {
        worksheetTemplatePipeline.addRow([pipeline.name]);
    });

    // Data Varian Harga
    let worksheetPriceVariant = workbook.addWorksheet('Daftar Varian Harga');
    await worksheetPriceVariant.protect('mjioerh3uiqWHEIOPHQWIOPEJHDWBH', {
        formatColumns: true,
        autoFilter: true,
    });

    worksheetPriceVariant.getCell('A1').value = `Daftar Varian Harga`;
    await param.dataPriceVariants.forEach((variant: any) => {
        worksheetPriceVariant.addRow([variant.variantPriceName]);
    });

    // Input Label Produk
    let worksheetProductLabel = workbook.addWorksheet('Label Produk (Opsional)');
    worksheetProductLabel.getRow(1).values = [...nameHeader.insert.productLabel.header];
    worksheetProductLabel.getRow(2).values = [...nameHeader.insert.productLabel.subHeader];
    setColumnWidths(worksheetProductLabel, source, [...nameHeader.insert.productLabel.header]);
    styleColumns(worksheetProductLabel, source, 1);
    styleColumns(worksheetProductLabel, source, 2);

    // Input Unit Produk
    let worksheetProductUnit = workbook.addWorksheet('Satuan Produk (Opsional)');
    worksheetProductUnit.getRow(1).values = [...nameHeader.insert.productUnit.header];
    worksheetProductUnit.getRow(2).values = [...nameHeader.insert.productUnit.subHeader];
    setColumnWidths(worksheetProductUnit, source, [...nameHeader.insert.productUnit.header]);
    styleColumns(worksheetProductUnit, source, 1);
    styleColumns(worksheetProductUnit, source, 2);

    // Input Varian Harga Produk
    let worksheetProductPriceVariant = workbook.addWorksheet('Harga Produk (Opsional)');
    worksheetProductPriceVariant.getRow(1).values = [...nameHeader.insert.productPriceVariant.header];
    worksheetProductPriceVariant.getRow(2).values = [...nameHeader.insert.productPriceVariant.subHeader];
    setColumnWidths(worksheetProductPriceVariant, source, [...nameHeader.insert.productPriceVariant.header]);
    styleColumns(worksheetProductPriceVariant, source, 1);
    styleColumns(worksheetProductPriceVariant, source, 2);

    if (typeAction === 'insert') {
        addDataRows({ intl, worksheet: worksheetProductLabel, data: [], source, type, typeAction, user, param, multiCurrencies, databasePipelineTitle });
        addDataRows({ intl, worksheet: worksheetProductUnit, data: [], source, type, typeAction, user, param, multiCurrencies, databasePipelineTitle });
        addDataRows({ intl, worksheet: worksheetProductPriceVariant, data: [], source, type, typeAction, user, param, multiCurrencies, databasePipelineTitle });

        header = [...nameHeader.insert.product.header];
        subHeader = [...nameHeader.insert.product.subHeader];

        if (type === 'error') {
            header.push('Error');
            subHeader.push(nameHeader.error);
            Array.from(param.listErrorInsert).forEach((row: any, index) => {
                var temp_excel = [];

                temp_excel.push(
                    row.name,
                    row.listLeadTemplateAccess,
                    row.isUsingVat ? intl.formatMessage({ id: 'FORM.LABEL.ACTIVE' }) : intl.formatMessage({ id: 'FORM.LABEL.NOT_ACTIVE' }),
                    row.sku,
                    row.note,
                );

                temp_excel.push(row.error)
                exportData.push(temp_excel);
            });
        }
    } else if (typeAction === 'update') {
        await worksheet.protect('mjioerh3uiqWHEIOPHQWIOPEJHQWIO', {
            formatColumns: true,
            autoFilter: true,
        });
        await worksheetProductLabel.protect('mjioerh3uiqWHEIOPHQWIOPEJHQWIO', {
            formatColumns: true,
            autoFilter: true,
        });
        await worksheetProductUnit.protect('mjioerh3uiqWHEIOPHQWIOPEJHQWIO', {
            formatColumns: true,
            autoFilter: true,
        });
        await worksheetProductPriceVariant.protect('mjioerh3uiqWHEIOPHQWIOPEJHQWIO', {
            formatColumns: true,
            autoFilter: true,
        });

        header = [...nameHeader.update.product.header];
        subHeader = [...nameHeader.update.product.subHeader];

        if (type === 'error') {
            header.push('Error');
            subHeader.push(nameHeader.error);
            Array.from(param.listErrorUpdate).forEach((row: any, index) => {
                var temp_excel = [];

                temp_excel.push(
                    btoa(row.id.slice(0, 3) + Math.floor(100 + Math.random() * 900) + row.id.slice(3)),
                    row.name,
                    row.listLeadTemplateAccess,
                    row.isUsingVat ? intl.formatMessage({ id: 'FORM.LABEL.ACTIVE' }) : intl.formatMessage({ id: 'FORM.LABEL.NOT_ACTIVE' }),
                    row.sku,
                    row.note,
                    row.color
                );

                temp_excel.push(row.error)
                exportData.push(temp_excel);
            });
        } else {
            let productLabelsData: any[] = [];
            let productUnitsData: any[] = [];
            let productPriceVariantsData: any[] = [];

            param.dataTables.forEach((row: any) => {
                var temp_excel = [];

                const pipelineNames = row.listLeadTemplateAccess.length === param.multiPipelines.length ? intl.formatMessage({ id: "FORM.LABEL.ALL" }, { title: intl.formatMessage({ id: "FORM.LABEL.TEMPLATE" }, { title: databasePipelineTitle }) }) :
                    row.listLeadTemplateAccess
                        .map((templateId: string) => {
                            const pipeline = param.multiPipelines.find((p: any) => p.id === templateId);
                            return pipeline ? pipeline.name : null
                        })
                        .filter((name: string | null) => name !== null)
                        .join(', ');

                temp_excel.push(
                    btoa(row.id.slice(0, 3) + Math.floor(100 + Math.random() * 900) + row.id.slice(3)),
                    row.name,
                    pipelineNames,
                    row.isUsingVat ? intl.formatMessage({ id: 'FORM.LABEL.ACTIVE' }) : intl.formatMessage({ id: 'FORM.LABEL.NOT_ACTIVE' }),
                    row.sku,
                    row.note,
                    row.color
                );

                exportData.push(temp_excel);

                const colIndex = 5; // sku
                const colLetter = getColumnLetter(colIndex);

                if (row.productLabels.length > 0) {
                    row.productLabels.forEach((l: any) => {
                        productLabelsData.push([{ formula: `Sheet1!${colLetter}${exportData.length + 2}` }, l.label.name]);
                    });
                }

                if (row.productUnits.length > 0) {
                    row.productUnits.forEach((u: any) => {
                        productUnitsData.push([
                            { formula: `Sheet1!${colLetter}${exportData.length + 2}` },
                            u.unit.name,
                            u.convertionToPieces,
                        ]);
                    });
                }

                if (row.prices.length > 0) {
                    const processPriceData = (prices: any, variants: any) => {
                        const variantMap = new Map();
                        variants.forEach((v: any) => {
                            variantMap.set(v.id, v.variantPriceName);
                        });

                        const groupedPrices = prices.reduce((acc: any, current: any) => {
                            const variantId = current.variantPriceId || 'Unassigned';
                            if (!acc[variantId]) {
                                acc[variantId] = {
                                    variantPriceName: variantMap.get(variantId),
                                    prices: {}
                                };
                            }
                            acc[variantId].prices[current.currencyId] = current.price;
                            return acc;
                        }, {});

                        const finalArray = Object.values(groupedPrices).map((item: any) => {
                            return [
                                {
                                    formula: `Sheet1!${colLetter}${exportData.length + 2}`
                                },
                                item.variantPriceName,
                                ...multiCurrencies.map((currency: MasterCurrency) => {
                                    return item.prices[currency.id];
                                })
                            ];
                        });

                        return finalArray;
                    };
                    const data = processPriceData(row.prices, param.dataPriceVariants)
                    productPriceVariantsData.push(...data)
                }
            });

            addDataRows({ intl, worksheet: worksheetProductLabel, data: productLabelsData, source, type, typeAction, user, param, multiCurrencies, databasePipelineTitle });
            addDataRows({ intl, worksheet: worksheetProductUnit, data: productUnitsData, source, type, typeAction, user, param, multiCurrencies, databasePipelineTitle });
            addDataRows({ intl, worksheet: worksheetProductPriceVariant, data: productPriceVariantsData, source, type, typeAction, user, param, multiCurrencies, databasePipelineTitle });
        }
    }

    worksheet.getRow(1).values = header;
    worksheet.getRow(2).values = subHeader;
    setColumnWidths(worksheet, source, header!);
    styleColumns(worksheet, source, 1);
    styleColumns(worksheet, source, 2);
    addDataRows({ intl, worksheet, data: exportData, source, type, typeAction, user, param, multiCurrencies, databasePipelineTitle });
    addWorkSheetInfo(worksheetInfo, source, nameFile, nameInfo, nameHeader, user!);

    exportWorkbook(workbook, `${nameFile}.xlsx`, setIsLoading);
}

interface AddDataRowsProps {
    intl: IntlShape,
    worksheet: ExcelJS.Worksheet,
    data: any[],
    source: string,
    type: string,
    typeAction: string,
    user: UserModel,
    param: any,
    multiCurrencies: MasterCurrency[]
    databasePipelineTitle: string
}

const addDataRows = ({ intl, worksheet, data, source, type, typeAction, user, param, multiCurrencies, databasePipelineTitle }: AddDataRowsProps) => {
    data.forEach((rowData, index) => {
        worksheet.addRow(rowData);
    });

    if (worksheet.name === 'Sheet1') {
        for (let i = 3; i <= 3; i++) {
            const cellLabel = worksheet.getCell(typeAction === 'insert' ? 'B' + i : 'C' + i);
            cellLabel.note = getCellNote(`Daftar Database ${databasePipelineTitle}`);
        }

        const vatColumnIndex = typeAction === 'insert' ? 3 : 4;
        const showVat = intl.formatMessage({ id: 'FORM.LABEL.ACTIVE' });
        const hideVat = intl.formatMessage({ id: 'FORM.LABEL.NOT_ACTIVE' });
        const vatOptions = `"${showVat},${hideVat}"`;
        const vatErrorMessage = `${intl.formatMessage({ id: 'EXCEL.VAT.VALUE' }, { show: showVat, hide: hideVat })}`
        for (let i = 3; i <= 500; i++) {
            const cell = worksheet.getCell(i, vatColumnIndex);
            cell.dataValidation = {
                type: 'list',
                allowBlank: false,
                showErrorMessage: true,
                formulae: [vatOptions], // Excel expects a quoted comma-separated list
                errorStyle: 'error',
                error: vatErrorMessage,
            };
        }
    }

    if (worksheet.name === 'Label Produk (Opsional)') {
        const colIndex = typeAction === 'insert' ? 4 : 5; // sku
        const colLetter = getColumnLetter(colIndex);

        for (let i = 3; i <= 500; i++) {
            worksheet.getCell('A' + i).dataValidation = {
                type: 'list',
                allowBlank: false,
                showErrorMessage: true,
                formulae: [`='Sheet1'!$${colLetter}$3:$${colLetter}$${503}`],
                errorStyle: 'error',
                error: 'Pilih SKU',
            };

            worksheet.getCell('B' + i).dataValidation = {
                type: 'list',
                allowBlank: false,
                showErrorMessage: true,
                formulae: [`='Daftar Label'!$A$2:$A$${param.dataLabels.length + 2}`],
                errorStyle: 'error',
                error: 'Pilih label',
            };
        }
    } else if (worksheet.name === 'Satuan Produk (Opsional)') {
        const colIndex = typeAction === 'insert' ? 4 : 5; // sku
        const colLetter = getColumnLetter(colIndex);
        for (let i = 3; i <= 500; i++) {
            worksheet.getCell('A' + i).dataValidation = {
                type: 'list',
                allowBlank: false,
                showErrorMessage: true,
                formulae: [`='Sheet1'!$${colLetter}$3:$${colLetter}$${503}`],
                errorStyle: 'error',
                error: 'Pilih SKU',
            };

            worksheet.getCell('B' + i).dataValidation = {
                type: 'list',
                allowBlank: false,
                showErrorMessage: true,
                formulae: [`='Daftar Satuan'!$A$2:$A$${param.dataUnits.length + 2}`],
                errorStyle: 'error',
                error: 'Pilih satuan',
            };
        }
    } else if (worksheet.name === 'Harga Produk (Opsional)') {
        const columnOffset = 3;

        multiCurrencies.forEach((currency: MasterCurrency, index) => {
            const priceColumn = worksheet.getColumn(columnOffset + index);
            priceColumn.numFmt = '#,##0.00;-#,##0.00';
        });

        const colIndex = typeAction === 'insert' ? 4 : 5; // sku
        const colLetter = getColumnLetter(colIndex);
        for (let i = 3; i <= 500; i++) {
            worksheet.getCell('A' + i).dataValidation = {
                type: 'list',
                allowBlank: false,
                showErrorMessage: true,
                formulae: [`='Sheet1'!$${colLetter}$3:$${colLetter}$${503}`],
                errorStyle: 'error',
                error: 'Pilih SKU',
            };

            worksheet.getCell('B' + i).dataValidation = {
                type: 'list',
                // allowBlank: false,
                // showErrorMessage: true,
                formulae: [`='Daftar Varian Harga'!$A$2:$A$${param.dataPriceVariants.length + 2}`],
                errorStyle: 'error',
                error: 'Pilih varian harga',
            };
        }
    }

    if (typeAction === 'update') {
        if (worksheet.name === 'Sheet1') {
            var dataLength = type === 'error' ? param.listErrorUpdate.length : param.dataTables.length;

            worksheet.eachRow({ includeEmpty: true }, function (row, rowIndex) {
                if (rowIndex > 2 && rowIndex <= dataLength + 2) {
                    const cell2 = row.getCell(2);
                    const cellListLeadTemplateAccess = row.getCell(3);
                    const cellVat = row.getCell(4);
                    const cellSKU = row.getCell(5);
                    const cellNote = row.getCell(6);

                    cellVat.numFmt = '#,##0';
                    cell2.protection = { locked: false };
                    cellListLeadTemplateAccess.protection = { locked: false };
                    cellVat.protection = { locked: false };
                    cellSKU.protection = { locked: false };
                    cellNote.protection = { locked: false };
                }
            });

        } else if (
            worksheet.name === 'Label Produk (Opsional)' ||
            worksheet.name === 'Satuan Produk (Opsional)' ||
            worksheet.name === 'Harga Produk (Opsional)'
        ) {
            for (let i = 3; i <= 500; i++) {
                const cell1 = worksheet.getCell('A' + i);
                const cell2 = worksheet.getCell('B' + i);

                cell1.protection = { locked: false };
                cell2.protection = { locked: false };

                if (worksheet.name === 'Satuan Produk (Opsional)') {
                    const cell3 = worksheet.getCell('C' + i);
                    cell3.protection = { locked: false };
                } else if (worksheet.name === 'Harga Produk (Opsional)') {
                    multiCurrencies.forEach((currency: MasterCurrency, index: number) => {
                        const columnIndex = index + 3;
                        const cell = worksheet.getCell(i, columnIndex);
                        cell.protection = { locked: false };
                    });
                }
            }
        }
    }

}